import React from 'react';

import { IconTypes } from '@eika/icon';

import CenteredModalContent from '../components/shared/CenteredModalContent/CenteredModalContent';
import SigningConfirmationDialog, { SigningConfirmationProps } from './SigningConfirmationDialog';
import SigningContextFlow, { Props as SigningContextFlowProps } from './SigningContextFlow';
import { useSigningContext } from './signingContext';
import useSigningConfirmation from './useSigningConfirmation';

type Props = {
    // @default false
    enable?: boolean;
} & SigningContextFlowProps &
    Omit<SigningConfirmationProps, 'onConfirm' | 'show' | 'onExitFocus' | 'icon'> &
    React.PropsWithChildren;

const SigningFlowWithConfirmation: React.FC<Props> = ({ enable = false, onClosePayment, children, ...rest }) => {
    const { showSigningFlow, handleCancelSigningFlow, signingOperationPending } = useSigningContext();
    const { showConfirmation, confirm, cancel } = useSigningConfirmation(
        enable,
        showSigningFlow || signingOperationPending,
        handleCancelSigningFlow,
    );

    if (!showSigningFlow) {
        return <>{children}</>;
    }

    if (showConfirmation) {
        return (
            <CenteredModalContent>
                <SigningConfirmationDialog
                    onConfirm={confirm}
                    show={showConfirmation}
                    onExitFocus={cancel}
                    icon={IconTypes.UTROPSTEGN_36}
                    {...rest}
                />
            </CenteredModalContent>
        );
    }

    return <SigningContextFlow onClosePayment={onClosePayment}>{children}</SigningContextFlow>;
};

export default SigningFlowWithConfirmation;
